import {getRepeatOptions} from "../api/repeatOptionsSubject";

export const repeatOptions = async () => {
    const res = await getRepeatOptions();
    const data = [];
    if (res && res.data && res.data.length > 0) {
        res.data.forEach((ele) => {
            data.push({value: ele, label: ele, repeat: ele});
        })
    }

    return data;
}